// src/features/tasks/services/completionApproval.js
import { apiClient } from '../../../services/api/client';

export const completionApprovalAPI = {
  // Get the adjusted completion date request attached to a task
  getApproval: (taskId) =>
    apiClient.get(`/api/v1/task-management/tasks/${taskId}/completion-approval`),

  // Accept the adjusted completion date
  approve: (taskId, data = {}) =>
    apiClient.post(`/api/v1/task-management/tasks/${taskId}/completion-approval/approve`, data),

  // Refuse the adjusted completion date and restore the original
  reject: (taskId, data = {}) =>
    apiClient.post(`/api/v1/task-management/tasks/${taskId}/completion-approval/reject`, data),
};
